module.exports = "<h1>404</h1>\n<h2>Page not found!</h2>\n<p>Sorry, the page you were trying to view does not exist.</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/error-pages/page-404/page-404.component.html
// module id = ./src/app/error-pages/page-404/page-404.component.html
// module chunks = main